__webpack_require__.p = "https://prod.sg.safer.whs.amazon.dev/";